import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "react-jss";
import Theme from "./styles/theme";
import "./styles/reset.css";
import "./styles/font.css";

const root = ReactDOM.createRoot(
   document.getElementById("root") as HTMLElement
);
root.render(
   <BrowserRouter>
      <React.StrictMode>
         <ThemeProvider theme={Theme}>
            <App />
         </ThemeProvider>
      </React.StrictMode>
   </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
